"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllGlossary = exports.getNotificationsGlossaryLang = exports.getNotificationsGlossary = void 0;
const enums_1 = require("./enums");
const glossaries_1 = require("./glossaries");
const messages_1 = require("./glossaries/messages");
const releases_1 = require("./glossaries/releases");
const glossary = {
    notifications: {
        [enums_1.AvailableEventsEnum.EVENT_DEVICE_MISSING]: glossaries_1.deviceMissingNotificationGlossary,
        [enums_1.AvailableEventsEnum.EVENT_SCENE_WARNING]: glossaries_1.sceneWarningNotificationGlossary,
        [enums_1.AvailableEventsEnum.EVENT_SCENE_SUCCESS]: glossaries_1.sceneSuccessNotificationGlossary,
        [enums_1.AvailableEventsEnum.EVENT_SCENE_FAILED]: glossaries_1.sceneFailedNotificationGlossary,
        [enums_1.AvailableEventsEnum.EVENT_MESSAGE]: messages_1.messageNotificationGlossary,
        [enums_1.AvailableEventsEnum.EVENT_RELEASE]: releases_1.releaseNotificationGlossary,
    },
    general: glossaries_1.generalGlossary,
};
const getNotificationsGlossary = (eventKind, version) => (glossary.notifications[eventKind][version]);
exports.getNotificationsGlossary = getNotificationsGlossary;
const getNotificationsGlossaryLang = ({ version, lang, }) => (eventKind) => ({
    contents: (props) => {
        const pushContents = (0, exports.getNotificationsGlossary)(eventKind, version).pushContents;
        return pushContents(props)[lang];
    },
});
exports.getNotificationsGlossaryLang = getNotificationsGlossaryLang;
const getAllGlossary = () => glossary;
exports.getAllGlossary = getAllGlossary;
